import { use } from "react";
import { useNavigate } from "react-router";
import Button, { IconButton } from "../../components/Button";
import Header from "../../components/Header";
import Add from "../../components/icons/add.svg?react";
import Panel from "../../components/Panel";
import UpgradeDialog from "../../components/UpgradeDialog";
import { BikeContext } from "../../context/bikeContext";
import { useEntitlements } from "../../hooks/useAccount";
import { useInfiniteBikes } from "../../hooks/useBikes";
import useToggle from "../../hooks/useToggle";
import { isEntitledTo } from "../../http/onlyclicksApi";
import Page from "../../layouts/Page";
import BikeList from "./BikeList";

const GaragePage = () => {
  const { bike } = use(BikeContext);
  const {
    data: bikes,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isPending,
  } = useInfiniteBikes();
  const { data: entitlements } = useEntitlements();
  const navigate = useNavigate();
  const upgradeDialog = useToggle();

  return (
    <>
      <Header backLink="/setups" heading="Garage">
        <IconButton
          glyph={Add}
          buttonProps={{
            disabled: entitlements === undefined,
            onClick: () => {
              isEntitledTo(entitlements!.bikes)
                ? navigate("/bikes/new")
                : upgradeDialog.open();
            },
          }}
        />
      </Header>
      <Page>
        <Panel title="Your bikes">
          <BikeList bikes={bikes} selectedBike={bike?.id} />
        </Panel>
        {hasNextPage && (
          <Button
            type="secondary"
            buttonProps={{
              onClick: () => {
                fetchNextPage();
              },
              disabled: isFetchingNextPage,
            }}
          >
            Load more
          </Button>
        )}
        {!isPending &&
          bikes &&
          Object.keys(bikes).length === 0 &&
          "Not bikes found"}
      </Page>
      <UpgradeDialog
        open={upgradeDialog.isOpen}
        onClose={upgradeDialog.close}
      />
    </>
  );
};

export default GaragePage;
